import { useContext } from "react";
import { useSelector } from "react-redux";

import { getAwardText } from "../../../selectors";
import { BaseBenefitsList } from "../../BaseComponents/BaseBenefitsList";
import { BaseColumnInformation } from "../../BaseComponents/BaseColumnInformation";
import { BaseCompanyLogo } from "../../BaseComponents/BaseCompanyLogo";
import BaseLinkWrapper from "../../BaseComponents/BaseLinkWrapper";
import BaseReviewLink from "../../BaseComponents/BaseReviewLink";
import BaseServiceFlag from "../../BaseComponents/BaseServiceFlag";
import { BaseTrustpilotReview } from "../../BaseComponents/BaseTrustpilotReview";
import { BaseVisitLink } from "../../BaseComponents/BaseVisitLink";
import { CompanyContext } from "../../CompanyList/CompanyContext";
import { PhoneLink } from "./PhoneLink";
import { getStyles } from "./styles";
import { DEFAULT_LINK_TEXT, ThemeContext } from "./ThemeContext";

export const InsuranceRankedColumns = () => {
	const { company } = useContext(CompanyContext);
	const {
		linkText = DEFAULT_LINK_TEXT,
		rendersPhoneLink = false,
		hasTrustpilotWidget = true,
	} = useContext(ThemeContext);
	const awardText = useSelector((state) => getAwardText(state, { company }));
	const styles = getStyles();

	return (
		<div
			className={`tw-relative tw-mt-[1.125rem] tw-rounded-[3px] [border-bottom:1px_solid_#f2f3f4]`}
		>
			<div className={`tw-bg-white`}>
				<div
					className={`tw-relative tw-mx-auto tw-flex tw-max-w-[500px] tw-flex-wrap tw-transition-all md:tw-max-w-none desktop:tw-flex-nowrap ${awardText ? "tw-pt-[1.85rem] xs:tw-pt-[1.5rem] desktop:tw-pt-0" : ""}`}
				>
					<BaseServiceFlag classNames={styles.serviceFlag} />
					<div
						className={`tw-flex tw-w-full tw-px-[15px] tw-pt-[15px] xs2:tw-pt-[20px] md:tw-py-[20px] md:tw-pl-[40px] md:tw-pr-[20px] desktop:tw-w-[20%] desktop:tw-px-0 ${awardText ? "desktop:tw-py-12" : "desktop:tw-py-0"}`}
					>
						<BaseLinkWrapper className="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-justify-center">
							<div className="tw-flex tw-w-full tw-items-center tw-justify-between xs2:tw-flex-wrap desktop:tw-items-start desktop:tw-justify-center">
								<div className="tw-flex tw-w-full tw-max-w-full tw-items-center tw-justify-center tw-text-center xs2:tw-max-w-[300px] md:tw-text-left">
									<BaseCompanyLogo classNames={styles.companyLogo} />
								</div>
								{hasTrustpilotWidget && (
									<BaseTrustpilotReview classNames={styles.trustpilotReview} />
								)}
							</div>
						</BaseLinkWrapper>
					</div>
					<div className="tw-float-right tw-flex tw-w-full tw-flex-wrap tw-items-start tw-justify-between tw-px-[15px] tw-py-[1.25rem] xs2:tw-px-[2.5rem] md:tw-pt-[10px] desktop:tw-w-[80%] desktop:tw-flex-nowrap desktop:tw-items-center desktop:tw-py-[15px] desktop:tw-pl-[15px] desktop:tw-pr-0 lg2:tw-p-[1.5rem]">
						<div className="tw-mx-auto tw-w-full tw-max-w-[690px] md:tw-mx-[initial]">
							<div className="tw-flex tw-flex-wrap tw-justify-between xs2:tw-justify-normal desktop:tw-flex-nowrap">
								<BaseLinkWrapper className="tw-flex tw-w-full tw-max-w-full tw-items-center desktop:tw-max-w-[305px] lg2:tw-max-w-[355px]">
									<BaseColumnInformation
										classNames={styles.columnInformation}
									/>
								</BaseLinkWrapper>
								<BaseLinkWrapper>
									<BaseBenefitsList
										{...styles.benefitsList}
										isExpandable={true}
										mobileItemsToShow={2}
									/>
								</BaseLinkWrapper>
							</div>
						</div>
						<div className="tw-mx-4 tw-flex tw-w-full tw-flex-wrap tw-items-center tw-justify-center xs:tw-flex-nowrap desktop:tw-w-auto lg2:tw-mr-0">
							<div className="tw-mt-4 tw-flex tw-w-full tw-max-w-[690px] tw-flex-col tw-flex-wrap tw-items-center tw-justify-evenly xs2:tw-flex-row-reverse md:tw-mx-4 md:tw-mb-0 md:tw-mt-[10px] desktop:tw-mx-0 desktop:tw-mt-0 desktop:tw-flex-col desktop:tw-items-center desktop:tw-justify-center">
								{rendersPhoneLink && <PhoneLink />}
								<BaseLinkWrapper className="tw-relative tw-inline-flex tw-h-[46px] tw-w-[175px] tw-max-w-[210px] tw-items-center tw-justify-center tw-rounded-[3px] tw-bg-[#1d8ce0] tw-text-base tw-font-semibold tw-text-white after:tw-ml-3 after:tw-h-[23px] after:tw-w-[23px] after:tw-bg-[url(/public/react-images/insuranceranked/dollarImage.svg)] after:tw-bg-cover after:tw-bg-no-repeat after:tw-ease-in-out after:[transition-duration:0.4s] hover:tw-bg-[#4ca0e0] xs2:tw-max-w-[initial]">
									<BaseVisitLink>{linkText}</BaseVisitLink>
								</BaseLinkWrapper>
								{!rendersPhoneLink && (
									<BaseReviewLink
										classNames={styles.reviewLink}
										linkText="Read Our Review"
									/>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
